/**
 * GoldenAgentCard
 * 
 * @Author: Focci
 * @Date: 2025-01-24 16:17:33
 * @Last Modified by: Focci
 * @Last Modified time: 2025-01-24 16:17:33
 */

'use client'

// import PropTypes from 'prop-types'
import UserTracking from '@comp/user-tracking'
import { useMemo } from 'react'
import { map } from 'lodash-es'
import PremiumMultiple from '../../agent/premium/PremiumMultiple'

export default function GoldenAgentCard({ data, ...props }) {
  const premiumListings = useMemo(() => map(
    data ? [data] : [],
    (house) => ({
      houseId: house.properties?.[0]?.id || 0, 
      suburbId: house.suburb_id || 0,
      agentId: house.agent?.id || 0,
      agencyOfficeId: house.agent?.office_id || 0,
      verticalType: 'buy',
      specialType: '',
    })
  ), [data])

  return (
    <>
      <div className="bg-cf0 text-f.7 leading-tight">
        <div className="text-helper px-2 md:px-4 pt-2">
          AGENT SHOWCASE LISTINGS
        </div>
        <div className="min-h-[16rem]">
          {data && <PremiumMultiple
            house={data} 
            slidesPerView="auto"
            {...props}
          />}
        </div>
      </div>
      {premiumListings.length > 0 && (
        <UserTracking
          eventName="show_premium_agent"
          params={premiumListings}
          once={true}
        />
      )}
    </>
  )
}

// GoldenAgentCard.propTypes = {
//   className: PropTypes.string,
// }
